import { connect } from 'react-redux';
// components
import { FRFriendListLoader } from './fr-friend-list-loader.component';
// types
import { State } from 'widgets/friends-referral/root/root.reducers';
import { IFRFriendListLoaderStoreProps } from './fr-friend-list-loader.types';

const mapStateToProps = (state: State): IFRFriendListLoaderStoreProps => ({
    env: state.config.envName,
    userId: state.login?.loginSession?.UbisoftConnectProfile.user.userId ?? '',
    shouldInheritStyles: state.config.shouldInheritStyles
});

export default connect(mapStateToProps)(FRFriendListLoader);
